import './IconGridWorld.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
var IconGridWorld = function IconGridWorld(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 18 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 18 : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 18 18",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067b9",
    d: "M17.978 8.4A8.998 8.998 0 0 0 9.6.02V0H8.4v.02A8.999 8.999 0 0 0 .02 8.4H0v1.2h.02a8.998 8.998 0 0 0 8.38 8.378V18h1.2v-.022A8.996 8.996 0 0 0 17.978 9.6H18V8.4h-.022zM5.634 1.962c-.58.77-1.06 1.736-1.411 2.838H2.425a7.841 7.841 0 0 1 3.209-2.838zM1.798 6h2.11a14.087 14.087 0 0 0-.296 2.4h-2.39A7.732 7.732 0 0 1 1.799 6zm-.575 3.6h2.389c.032.836.134 1.642.295 2.4h-2.11a7.732 7.732 0 0 1-.574-2.4zm1.202 3.6h1.797c.35 1.102.831 2.068 1.412 2.838A7.833 7.833 0 0 1 2.425 13.2zM8.4 16.723c-1.234-.33-2.296-1.655-2.94-3.523H8.4v3.523zM8.4 12H5.123a13.412 13.412 0 0 1-.311-2.4H8.4V12zm0-3.6H4.812c.035-.845.142-1.652.31-2.4H8.4v2.4zm0-3.6H5.46c.644-1.868 1.706-3.193 2.94-3.522V4.8zm7.175 0H13.78c-.352-1.102-.832-2.068-1.414-2.838A7.849 7.849 0 0 1 15.575 4.8zM9.6 1.278c1.232.329 2.296 1.654 2.94 3.522H9.6V1.278zM9.6 6h3.276c.17.748.275 1.555.312 2.4H9.6V6zm0 3.6h3.588a13.302 13.302 0 0 1-.312 2.4H9.6V9.6zm0 7.123V13.2h2.94c-.644 1.868-1.708 3.193-2.94 3.523zm2.766-.685c.58-.772 1.062-1.736 1.414-2.838h1.795a7.84 7.84 0 0 1-3.209 2.838zM16.202 12h-2.11c.162-.758.264-1.564.296-2.4h2.388a7.698 7.698 0 0 1-.574 2.4zm-1.814-3.6a14.251 14.251 0 0 0-.295-2.4h2.11c.311.748.51 1.555.574 2.4h-2.389z"
  }));
};
var StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "sh7rq70"
});
export default IconGridWorld;